// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Composite API
 * HTTP API for managing Neo4j composite database instances.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HandlersPatchCompositeInstanceInternalResult } from './HandlersPatchCompositeInstanceInternalResult';
import {
  HandlersPatchCompositeInstanceInternalResultFromJSON,
  HandlersPatchCompositeInstanceInternalResultFromJSONTyped,
  HandlersPatchCompositeInstanceInternalResultToJSON,
  HandlersPatchCompositeInstanceInternalResultToJSONTyped,
} from './HandlersPatchCompositeInstanceInternalResult';

/**
 *
 * @export
 * @interface HandlersPatchCompositeInstancesInternalResponse
 */
export interface HandlersPatchCompositeInstancesInternalResponse {
  /**
   *
   * @type {Array<HandlersPatchCompositeInstanceInternalResult>}
   * @memberof HandlersPatchCompositeInstancesInternalResponse
   */
  results?: Array<HandlersPatchCompositeInstanceInternalResult>;
}

/**
 * Check if a given object implements the HandlersPatchCompositeInstancesInternalResponse interface.
 */
export function instanceOfHandlersPatchCompositeInstancesInternalResponse(
  value: object,
): value is HandlersPatchCompositeInstancesInternalResponse {
  return true;
}

export function HandlersPatchCompositeInstancesInternalResponseFromJSON(
  json: any,
): HandlersPatchCompositeInstancesInternalResponse {
  return HandlersPatchCompositeInstancesInternalResponseFromJSONTyped(
    json,
    false,
  );
}

export function HandlersPatchCompositeInstancesInternalResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HandlersPatchCompositeInstancesInternalResponse {
  if (json == null) {
    return json;
  }
  return {
    results:
      json['results'] == null
        ? undefined
        : (json['results'] as Array<any>).map(
            HandlersPatchCompositeInstanceInternalResultFromJSON,
          ),
  };
}

export function HandlersPatchCompositeInstancesInternalResponseToJSON(
  json: any,
): HandlersPatchCompositeInstancesInternalResponse {
  return HandlersPatchCompositeInstancesInternalResponseToJSONTyped(
    json,
    false,
  );
}

export function HandlersPatchCompositeInstancesInternalResponseToJSONTyped(
  value?: HandlersPatchCompositeInstancesInternalResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    results:
      value['results'] == null
        ? undefined
        : (value['results'] as Array<any>).map(
            HandlersPatchCompositeInstanceInternalResultToJSON,
          ),
  };
}
